import CustomerMap from './CustomerMap';

export default CustomerMap;
